import { makeStyles } from "@material-ui/core/styles";
const UseStyles = makeStyles((theme) => ({
  main_grid: {
    backgroundColor: "#F5F5F5",
  },
  cell_header_bold: {
    color: "black",
    fontWeight: "bold",
    fontSize: "0.75rem !important",
  },
  header_bold: {
    color: "black",
    fontWeight: "bold",
    fontSize: "0.75rem !important",
  },
  grid_space: {
    // margin: "0.5rem",
    boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
    padding: "0.5rem",
    // color: "black",
  },
  deal_grid_selected: {
    color: "#FFFFFF !important",
    backgroundColor: "#4B4E6D !important",
  },
  text_color_set: {
    color: "white",
    fontSize: "0.75rem !important",
  },

  row_color1: {
    backgroundColor: "FFFFFF",
    color: "white",
  },
  row_color2: {
    backgroundColor: "#F5F5F5",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "space-around",
  },
  verticalGap: {
    marginTop: "5px",
    marginBottom: "5px",
  },
  input: {
    display: "none",
  },
  pink: {
    backgroundColor: "#F2DEDE",
  },
  green: {
    backgroundColor: "#DFF0D8",
  },
  BackGroundSet: {
    background: "linear-gradient(90deg, #f9ebea, #d7dbdd) !important",
  },
  box_design: {
    // border: "3px solid rgba(224, 224, 224, 1)",
    padding: "0.25rem 0.75rem",
    background: "#F5F5F5",
    fontSize: "0.75rem !important",
  },
  text_color_No: {
    color: "#B94A48",
  },
  text_color_Yes: {
    color: "#468847",
  },
  table_border: {
    border: ".5px solid gray",
    color: "black",
  },
  Attachment_Button: {
    backgroundColor: "#53CD37",
    color: "white",
  },
  Attached_Button: {
    backgroundColor: "#F3A539",
    color: "white",
  },

  fontColorFundRec: {
    color: "black", // (default alpha is 0.38)
  },

  header_color: {
    border: ".5px solid gray",
    color: "#000000",
    fontWeight: "bold",
  },

  textBoxDesign: {
    fontSize: "0.75rem !important",
  },
  applicantIcon: {
    fontSize: "1.0rem !important",
    borderRadius: "5px",
    padding: "3px",
  },
  applicantHead: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  headerText: {
    fontSize: "1.0rem !important",
    padding: "0.25rem 0.75rem",
    color: "#2d2d2d",
  },
  fundedDealText: {
    fontSize: "1.0rem !important",
    fontWeight: "bold",
    padding: "0.25rem 0.75rem",
    color: "#2d2d2d",
    border: "none !important",
  },
  headerTextApplicant: {
    fontSize: "1.0rem !important",
    padding: "0.25rem 0.75rem",
    marginTop: "8px",
    color: "#2d2d2d",
  },
  table: {
    "& th": {
      padding: "0.25rem 0.75rem",
      lineHeight: "1.2rem",
    },
    "& td": {
      padding: "0.25rem 0.75rem",
      lineHeight: "1.2rem",
      fontSize: "0.75rem !important",
    },
    "& tr:nth-child(even)": {
      backgroundColor: "#F9F9F9",
    },
  },

  tableContainer: {
    boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
  },
  tableShadow: {
    boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
    padding: "1rem",
  },
  invoiceAmountFld: {
    border: "0px solid blue",
    borderRadius: "3px",
    color: "black",
    width: "100%",
    height: "35px",
    fontSize: "0.75rem !important",
  },
  buttonDesign: {
    cursor: "pointer",
    borderRadius: "4px",
  },
  containerShadow: {
    backgroundColor: "#F9F9F3",
    color: "#2d2d2d",
    boxShadow: "0 0 10px 1px rgb(224 224 224)",
    padding: "0.3rem",
  },
  cleaveInput: {
    display: "flex",
    marginLeft: "4px",
    width: "100%",
    "& input": {
      width: "100%",
      padding: "6px 8px !important",
      fontSize: "0.75rem",
      border: "none",
      borderRadius: "0 !important",
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
    "& input:focus": {
      outline: "none",
      borderBottom: "2px solid #3f51b5 !important",
    },
  },
}));

export default UseStyles;
